import type { DailyGoalHistoryGoal } from "@consistency-circle/shared";

import { Progress } from "@/components/ui/progress";

export function GoalBreakdownCard({ goal }: { readonly goal: DailyGoalHistoryGoal }) {
  const trackedDays = goal.days.filter((day) => day.totalCount > 0);
  const completed = goal.days.reduce((acc, day) => acc + day.completedCount, 0);
  const total = goal.days.reduce((acc, day) => acc + day.totalCount, 0);
  const percent =
    trackedDays.length > 0
      ? Math.round(
          trackedDays.reduce((acc, day) => acc + day.completionPercent, 0) / trackedDays.length,
        )
      : 0;

  return (
    <div className="space-y-2 rounded-xl border border-border bg-card px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <span className="truncate text-sm font-medium">{goal.name}</span>
        <span
          className={`shrink-0 text-sm font-semibold tabular-nums ${
            percent >= 80
              ? "text-primary"
              : percent > 0
                ? "text-foreground"
                : "text-muted-foreground"
          }`}
        >
          {total === 0 ? "-" : `${percent}%`}
        </span>
      </div>
      <Progress value={percent} className="h-1.5" />
      <p className="text-xs text-muted-foreground">
        {completed} of {total} actions completed
      </p>
    </div>
  );
}
